import { get,post } from '@/utils/axios'

export default {
    
    // 管理登录
    signIn(datas){
        return get('login/login',datas)
    }
}